var _excluded = ["align", "as", "children", "className", "color", "inverse", "marginBottom", "marginLeft", "marginRight", "marginTop", "size", "variation"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { forwardRef } from 'react';
import Typography from "../Typography";
import { useTheme } from 'styled-components';

/**
 * Documentation:
 *
 * - [Link for Windows (On-prem)](https://pages.ghe.service.group/constellation/docs/components/heading)
 **/
var Heading = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$align = _ref.align,
    align = _ref$align === void 0 ? 'inherit' : _ref$align,
    _ref$as = _ref.as,
    as = _ref$as === void 0 ? 'span' : _ref$as,
    children = _ref.children,
    className = _ref.className,
    colorProp = _ref.color,
    inverseProp = _ref.inverse,
    _ref$marginBottom = _ref.marginBottom,
    marginBottom = _ref$marginBottom === void 0 ? '05' : _ref$marginBottom,
    _ref$marginLeft = _ref.marginLeft,
    marginLeft = _ref$marginLeft === void 0 ? 'none' : _ref$marginLeft,
    _ref$marginRight = _ref.marginRight,
    marginRight = _ref$marginRight === void 0 ? 'none' : _ref$marginRight,
    _ref$marginTop = _ref.marginTop,
    marginTop = _ref$marginTop === void 0 ? 'none' : _ref$marginTop,
    _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? 's4' : _ref$size,
    variation = _ref.variation,
    rest = _objectWithoutProperties(_ref, _excluded);
  var theme = useTheme() || {};
  var color = colorProp;
  var inverse = inverseProp;
  var size = sizeProp;

  /** @ts-ignore Invalid prop value allowed for deprecation purposes */
  if (colorProp === 'negative' || colorProp === 'error') {
    color = 'critical';
    console.warn("Value \"".concat(colorProp, "\" provided to `color` prop is deprecated. Use \"").concat(color, "\" instead."));
  }

  /** @ts-ignore Invalid prop value allowed for deprecation purposes */
  if (['info', 'label', 'positive', 'title', 'warning'].includes(colorProp)) {
    color = 'normal';
    console.warn("Value \"".concat(colorProp, "\" provided to `color` prop is deprecated. Use \"").concat(color, "\" instead."));
  }

  /** @ts-ignore Invalid prop value allowed for deprecation purposes */
  if (colorProp === 'primary') {
    color = 'brand';
    console.warn("Value \"".concat(colorProp, "\" provided to `color` prop is deprecated. Use \"").concat(color, "\" instead."));
  }

  /** @ts-ignore Invalid prop value allowed for deprecation purposes */
  if (inverseProp === undefined && colorProp === 'white') {
    inverse = true;
    console.warn('The `color` prop on `Heading` component of value `white` is deprecated. Please ' + 'use `inverse` prop instead, or use the `<inverse />` context.');
  }
  if (variation) {
    console.warn('The `variation` prop on `Heading` component is deprecated. Please ' + 'use `size` prop to specify font size, and `element` to specify HTML tag.');
  }
  if (variation === 'h1') {
    size = 's7';
  }
  if (variation === 'h2') {
    size = 's6';
  }
  if (variation === 'h3') {
    size = 's5';
  }
  if (variation === 'h4') {
    size = 's4';
  }
  return /*#__PURE__*/React.createElement(Typography, _extends({
    align: align,
    as: as,
    className: className,
    color: color,
    inverse: inverse,
    marginBottom: marginBottom,
    marginLeft: marginLeft,
    marginRight: marginRight,
    marginTop: marginTop,
    ref: ref,
    role: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'].includes(as) ? undefined : 'heading',
    size: size,
    variation: "heading",
    weight: theme["heading_config_".concat(size, "_font_weight")] || 'bold'
  }, rest), children);
});
Heading.displayName = 'Heading';
export default Heading;